import {
  isPoweredByCWTextShown,
  poweredByCwLogoUrl,
} from 'src/utils/capabilities';
import { PoweredByCW } from './styles';

const Footer = () => {
  if (isPoweredByCWTextShown && poweredByCwLogoUrl) {
    return (
      <PoweredByCW src={poweredByCwLogoUrl} alt="Powered by coverwallet" />
    );
  }
  return null;
};

export { Footer };
